// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-body[data-v-f2797340] .el-card__body {\n  padding-top: 0px;\n}", ""]);
// Exports
module.exports = exports;
